module.exports = __webpack_public_path__ + "img/logo_header.a4d71671.svg";